export default __webpack_public_path__ + "static/media/45.b7beb6f0.svg";